import { SupportTicketStatus } from './SupportTicket.js';

class SupportTicketHelpers {
  static isTicketClosed(ticket) {
    return ticket.status === SupportTicketStatus.CLOSED;
  }
}

export { SupportTicketHelpers };
//# sourceMappingURL=SupportTicketHelpers.js.map
